import { useT } from "../i18n";
import { Instagram } from "lucide-react";
import { scrollToId } from "../lib/lenis";
import { LangToggle } from "./Nav";

export const Footer = () => {
  const t = useT();

  return (
    <footer className="bg-bergamote-900 text-cream-50 pt-20 pb-10 overflow-hidden" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="pb-14 border-b border-bergamote-300/15">
          <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-8">
            <div>
              <p className="text-sm text-bergamote-300">{t.footer_tagline}</p>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-widest text-bergamote-300/70">{t.contact_address} · {t.contact_phone}</p>
            </div>
            <div className="flex items-center gap-6">
              <nav className="flex flex-wrap gap-x-5 gap-y-2 text-sm">
              {[["nav_menu", "menu"], ["nav_gallery", "gallery"], ["nav_reviews", "reviews"], ["nav_contact", "visit"]].map(([key, id]) =>
                id === "menu" ? (
                  <a
                    key={key}
                    href="/_files/ugd/bbb9df_ac87e01cbc2f416ab03b45184d98ab77.pdf?v=13"
                    data-testid="footer-link-menu"
                    className="text-bergamote-200 hover:text-saffron-400 transition-colors duration-300"
                  >
                    {t[key]}
                  </a>
                ) : (
                  <button
                    key={key}
                    data-testid={`footer-link-${id}`}
                    onClick={() => scrollToId(id)}
                    className="text-bergamote-200 hover:text-saffron-400 transition-colors duration-300"
                  >
                    {t[key]}
                  </button>
                )
              )}
            </nav>
            <LangToggle />
          </div>
          </div>
        </div>

        <p aria-hidden className="font-serif font-bold text-[13vw] leading-none text-center select-none pointer-events-none mt-10" style={{ WebkitTextStroke: "1px rgba(163,201,153,0.22)", color: "transparent" }}>
          Bergamote
        </p>

        <div className="mt-10 flex justify-center">
          <a
            href="https://www.instagram.com/la_bergamote_geneve"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-instagram-link"
            className="group inline-flex items-center gap-2.5 rounded-full border border-cream-50/40 text-cream-50 px-7 py-3.5 text-sm font-semibold hover:bg-bergamote-800 hover:-translate-y-0.5 transition-[background-color,transform] duration-300"
          >
            <Instagram className="w-4 h-4 text-saffron-500 group-hover:scale-110 transition-transform duration-300" />
            <span>
              {t.footer_instagram}{" "}
              <span className="font-semibold text-cream-50 group-hover:text-saffron-400 transition-colors duration-300">@la_bergamote_geneve</span>
            </span>
          </a>
        </div>

        <p className="mt-8 text-center font-mono text-[11px] uppercase tracking-[0.25em] text-bergamote-300/60" data-testid="footer-copyright">
          © {new Date().getFullYear()} {t.footer_rights}
        </p>
      </div>
    </footer>
  );
};
